<div>
  <mat-toolbar color="primary">
    <span>Map polyline tool</span>

    <span class="toolbar-spacer"></span>

    <app-export-data></app-export-data>

    <a class="dev-info" href="https://github.com/sarweshkumar47/map-polyline-tool" target="_blank">Source on Github</a>

  </mat-toolbar>
</div>